import { render, staticRenderFns } from "./IntroduceMyselfPage.vue?vue&type=template&id=0a901787&scoped=true"
import script from "./IntroduceMyselfPage.vue?vue&type=script&lang=js"
export * from "./IntroduceMyselfPage.vue?vue&type=script&lang=js"
import style0 from "./IntroduceMyselfPage.vue?vue&type=style&index=0&id=0a901787&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a901787",
  null
  
)

export default component.exports